import React from "react";
import { Box, Typography } from "@mui/material";
import FacilityNetworkIcon from "@icons/FacilityNetworkIcon";
import { FN } from "./facilityNetworkTheme";

type Props = {
  title?: string;
  badge?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  hideSeparator?: boolean;
  compactTop?: boolean;
};

export default function FacilityNetworkTitleRow({
  title = "Facility network",
  badge = "Your position in the facility hierarchy and all linked facilities",
  icon = <FacilityNetworkIcon size={FN.pageTitleIconSize} fill={FN.title} />,
  action,
  hideSeparator = false,
  compactTop = false,
}: Props) {
  return (
    <Box
      sx={{
        mt: compactTop ? 1.625 : FN.tabsToTitle,
        mb: hideSeparator ? 0 : FN.titleBelowSeparator,
        pb: 0,
        borderBottom: "none",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: 0.75,
            minWidth: 0,
            flex: 1,
          }}
        >
          {icon}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, minWidth: 0 }}>
            <Typography
              sx={{
                fontFamily: FN.fontFamily,
                fontSize: FN.pageTitleSize,
                fontWeight: 500,
                color: FN.title,
                letterSpacing: "-0.3px",
                lineHeight: 1.3,
              }}
            >
              {title}
            </Typography>
            {badge ? (
              <Typography
                sx={{
                  fontFamily: FN.fontFamily,
                  fontSize: 12,
                  fontWeight: 400,
                  color: FN.figmaAccent,
                  letterSpacing: "0.25px",
                  lineHeight: "16px",
                }}
              >
                {badge}
              </Typography>
            ) : null}
          </Box>
        </Box>
        {action ? <Box sx={{ flexShrink: 0 }}>{action}</Box> : null}
      </Box>
    </Box>
  );
}
